import { Pipe, PipeTransform, Input } from '@angular/core';

@Pipe({
  name: 'filterCheckout',
  pure: false,
})
export class FilterCheckoutPipe implements PipeTransform {
  transform(value: any, screen): any {
    if (value && value.length > 0 && screen === 'checkoutLater') {
      return value.filter((item) => {
        return item.checkoutLater;
      });
    } else if (value && value.length > 0 && (screen === 'summary' || screen === 'cart')) {
      return value.filter((item) => {
        return !item.checkoutLater;
      });
    } else {
      return value;
    }
  }
}
